import { render, staticRenderFns } from "./ImgResponsive.vue?vue&type=template&id=bdf8badc&scoped=true&lang=pug&"
import script from "./ImgResponsive.vue?vue&type=script&lang=js&"
export * from "./ImgResponsive.vue?vue&type=script&lang=js&"
import style0 from "./ImgResponsive.vue?vue&type=style&index=0&id=bdf8badc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf8badc",
  null
  
)

export default component.exports